module.exports = __webpack_public_path__ + "img/s3amazon.5d361a5c.png";